import {EntitiesForDistrictRequested} from './EntitiesForDistrictRequested';

/**
 * This event can be fired to indicate, that a services requires news linked to a certain district.
 * Another service, that is eligible to provide this info will put batches of the requested data into
 * the specified S3 `targetBucket`, using the `transactionId` as prefix (subfolder).
 */
export class NewsForDistrictRequested extends EntitiesForDistrictRequested {}
